import { render, staticRenderFns } from "./PopOver.vue?vue&type=template&id=1aea49a8"
import script from "./PopOver.vue?vue&type=script&lang=js"
export * from "./PopOver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aea49a8')) {
      api.createRecord('1aea49a8', component.options)
    } else {
      api.reload('1aea49a8', component.options)
    }
    module.hot.accept("./PopOver.vue?vue&type=template&id=1aea49a8", function () {
      api.rerender('1aea49a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/institution/PopOver.vue"
export default component.exports